import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';
import { AppComponent } from 'src/app/app.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register-property',
  templateUrl: './register-property.component.html',
  styleUrls: ['./register-property.component.css']
})
export class RegisterPropertyComponent implements OnInit {

  region_id = '';
  name = '';
  email = '';
  mobile_no = '';
  address = '';
  property_type_id = '';
  property_use_type_id = '';
  property_zip_code = '';
  property_address = '';
  tax_number = '';
  tax_number_type = "";
  modelData: any = {};
  ulb_id: any = environment.ulb_id;
  prop_type_data : any = [];
  prop_use_type_data : any = [];
  env = environment;
  user_details: any = [];
  user_dtl: any = [];
  PAN = '';
  GST = '';
  property_area: any = [];
  total_dimention = '';
  property_area_width = '';
  property_area_length = "";
  area_type = '';
  property_use_type_slug = "";
  is_commercial= false;
  isDisabled = false;


  constructor(private apiService : ApiService, private appComponent : AppComponent,
    private router: Router) { }

  ngOnInit(): void {
    this.getPropertyUseTypesList();
    this.getModelData('regionHierarchyUlb');
    
    this.user_details = localStorage.getItem("loginDetails");
    if(this.user_details == null){
      this.router.navigate(['/login'], { queryParams: { returnUrl: '/register-property' }});
    }
    this.user_dtl = JSON.parse(this.user_details).user[0];
    this.name= this.user_dtl.name;
    this.email= this.user_dtl.email;
    this.mobile_no= this.user_dtl.mobile_no;

  }

  OnSelectPanGst(data : any){
    console.log(this.tax_number_type);
  }

  getTotalArea(data : any) {
    this.property_area = Number(this.property_area_width) * Number(this.property_area_length);
    // data.property_area = this.property_area;
    // console.log(data.property_area);
  }

  getModelData(field_name : string) {
    
    this.appComponent.showLoader();
    this.apiService.get('model_data_public/2?ulb_id=' + this.ulb_id +'&logical_region=no').subscribe(res => {
      this.modelData[field_name] = JSON.parse(JSON.stringify([res.data]));
      this.modelData[field_name][0]['field_index'] = 0;
      this.modelData['regionHierarchyUlb'][0].ngmodel = '';
      this.appComponent.hideLoader();
    },
    (error) =>{
      this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      this.appComponent.hideLoader();
    })
  }

  getPropertyTypesList(){
    let property_type_obj = this.prop_use_type_data.find((val: any) => { return val.id == this.property_use_type_id});
    this.is_commercial = false;
    if(property_type_obj.is_commercial){
      this.is_commercial = true;
    }else{
      this.is_commercial = false;
    }

    this.appComponent.showLoader();
    this.apiService.getCitizenData(`property_types?property_use_type_id=`+ this.property_use_type_id).subscribe((res) =>{
      this.prop_type_data = res.data;
      this.appComponent.hideLoader();
    },
    (error) =>{
      this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      this.appComponent.hideLoader();
    })
  }

  getPropertyUseTypesList(){
    this.appComponent.showLoader();
    this.apiService.getCitizenData(`property_use_types`).subscribe((res) =>{
      this.prop_use_type_data = res.data;
      this.appComponent.hideLoader();
    }, 
    (error) =>{
      this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      this.appComponent.hideLoader();
    })
  }

  submitProperty(data : any){
    if(data.property_area){
      this.property_area = data.property_area;
    }

    let formData = {
      name: this.name,
      email: this.email,
      mobile_no: this.mobile_no,
      address: this.address,
      region_id: this.region_id,
      property_address: data.property_address,
      property_type_id: this.property_type_id,
      property_use_type_id: this.property_use_type_id,
      property_zip_code: data.property_zip_code,
      property_region_id: this.region_id,
      tax_number: data.tax_number || null,
      tax_number_type: data.tax_number_type || null,
      property_area: this.property_area
    }
    // console.log(formData);
    
    this.isDisabled = true;

    this.apiService.postCitizenData(`register_property`, formData).subscribe(
      (res: any) => {
          this.router.navigate(['/user-property-list']);
      },
      (error) => {
        this.isDisabled = false;
        this.appComponent.showMessageAlert(error.error.error[0].message, 'error');
      })
  }

  modelChange(_value : any, _model: any, field_name: any, _index: any, model_id:any) {

    let modelData = JSON.parse(JSON.stringify(this.modelData[field_name]));

    let i = modelData.length; //initialize counter to array length

    while (i--) //decrement counter
    {
      if ((this.modelData[field_name][i] && this.modelData[field_name][i].field_index) > _index) {
        this.modelData[field_name].splice(i, 1);
      }

    }

    this.region_id = _value.value;

    if (_value.field_data.length <= 0) {

    }
    else {
      let index = this.modelData[field_name].findIndex((item: any) => item.field_label == _value.field_label);
      if (index == -1) {
        _value.field_index = _index + 1;
        _value.ngmodel = '';
        this.modelData[field_name].push(_value);
      }
    }

  }

}